import { lazy, JSX } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import PrivateRoute from './pages/users/partials/auth/private_route';

const EmptyLayout = lazy(() => import('./layouts/empty'));
const NewLayout = lazy(() => import('./layouts/new'));
const Layout = lazy(() => import('./layouts/layout'));
const POSIndex = lazy(() => import('./pages/pos'));
const CashierIndex = lazy(() => import('./pages/cashier'));
const OrdersIndex = lazy(() => import('./pages/orders'));
const InventoryIndex = lazy(() => import('./pages/inventory'));
const InventoryDetail = lazy(() => import('./pages/inventory/detail'));
const InventoryNew = lazy(() => import('./pages/inventory/new'));
const InventoryConfirm = lazy(() => import('./pages/inventory/confirm'));
const UsersIndex = lazy(() => import('./pages/users'));
const ErrorsIndex = lazy(() => import('./pages/errors'));

function App() {
  const evRoute = (path: string, element:JSX.Element, as?: string, isStore= true as boolean, layoutElement?:JSX.Element) => {
    const layout = layoutElement || <Layout />;
    return (
      <Route path={path} element={<PrivateRoute as={as} isStore={isStore} />}>
        <Route element={layout}>
          <Route index element={element} />
        </Route>
      </Route>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path={'/users'} element={<EmptyLayout />}>
          <Route index element={<UsersIndex />} />
          <Route path='xyz' element={<UsersIndex />} />
          <Route path='forgot' element={<UsersIndex />} />
          <Route path='login' element={<UsersIndex />} />
          <Route path='verify' element={<UsersIndex />} />
        </Route>

        <Route path={'/restricted'} element={<ErrorsIndex section='restricted' />} />

        { evRoute('/inventory/adjustment/confirm/:id', <InventoryConfirm sections='adjustment'/>, 'pos', true, <NewLayout />) }
        { evRoute('/inventory/inbound/confirm/:id', <InventoryConfirm sections='inbound'/>, 'pos', true, <NewLayout />) }
        { evRoute('/inventory/outbound/confirm/:id', <InventoryConfirm sections='outbound'/>, 'pos', true, <NewLayout />) }
        
        { evRoute('/inventory/adjustment/:id', <InventoryDetail sections='adjustment'/>, 'pos') }
        { evRoute('/inventory/inbound/:id', <InventoryDetail sections='inbound'/>, 'pos') }
        { evRoute('/inventory/outbound/:id', <InventoryDetail sections='outbound'/>, 'pos') }

        { evRoute('/inventory/adjustment/new', <InventoryNew sections='adjustment'/>, 'pos', true, <NewLayout />) }
        { evRoute('/inventory/inbound/new', <InventoryNew sections='inbound'/>, 'pos', true, <NewLayout />) }
        { evRoute('/inventory/outbound/new', <InventoryNew sections='outbound'/>, 'pos', true, <NewLayout />) }

        { evRoute('/inventory/quantity', <InventoryIndex sections='quantity'/>, 'pos') }
        { evRoute('/inventory/adjustment', <InventoryIndex sections='adjustment'/>, 'pos' ) }
        { evRoute('/inventory/inbound', <InventoryIndex sections='inbound'/>, 'pos') }
        { evRoute('/inventory/outbound', <InventoryIndex sections='outbound'/>, 'pos') }
        { evRoute('/inventory/history', <InventoryIndex sections='history'/>, 'pos') }

        { evRoute('/cashier', <CashierIndex />, 'pos') }

        { evRoute('/orders', <OrdersIndex />, 'pos') }
        
        { evRoute('/', <POSIndex />, 'pos', false) }
        
        <Route path='*' element={<ErrorsIndex section='not-found' />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
